import { handleApiError } from '@api';
import config from '@config';
import { HTTPClient, isAbortError } from '@platform2-lib/httpz';
import * as schema from '@schema';
import type { Dataset, RelevantAudience } from 'types/schema';

const client = new HTTPClient(
  config.env,
  `${config.api.origin}/spark-agent-v2`
);

export interface AudienceSearchProps {
  searchTerm: string;
  currentIds?: ReadonlyArray<RelevantAudience['id']>;
  datasetCode?: Dataset['id'];
  abortSignal?: AbortSignal;
}

const search = async ({
  searchTerm,
  currentIds,
  datasetCode,
  abortSignal
}: AudienceSearchProps): Promise<RelevantAudience[]> => {
  const queryParams = new URLSearchParams();
  queryParams.set('searchTerm', searchTerm);

  if (currentIds && currentIds.length > 0) {
    queryParams.set('audienceIds', currentIds.join(','));
  }

  if (datasetCode) {
    queryParams.set('datasetCode', datasetCode);
  }

  try {
    const response = await client.get(
      `/audiences/relevant?${queryParams.toString()}`,
      schema.RelevantAudiencesResponse,
      {
        signal: abortSignal
      }
    );

    return response.audiences;
  } catch (error: unknown) {
    if (isAbortError(error)) {
      return [];
    }

    handleApiError(error, 'Failed to retrieve the relevant audiences.');

    return [];
  }
};

export const audiences = {
  search
};
